<script>
import _ from 'lodash'
import NumberUtils from '@/utils/number'
import service from '@/request/base'
export default {
  name: 'DatabankNormcaseShow',
  props: {
    normcase: {
      type: Object,
      default () {
        return {}
      }
    },
    paragraphs: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  computed: {},
  created: function () {},
  mounted: function () {},
  beforeDestroy () {},
  watch: {},
  methods: {
    showDoctor () {
      if (_.isEmpty(this.normcase)) {
        return
      }
      let doctor = NumberUtils.idFromString(this.normcase.operator) || null
      if (!doctor) {
        this.$message({
          message: '这个病例的医生非医步用户',
          type: 'info'
        })
        return
      }
      this.$router.push({name: 'databank_normcasedoctor', params: {id: doctor}})
    },
    isImage (url) {
      let type = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
      return _.indexOf(['jpg', 'jpeg', 'png', 'bmp'], type) >= 0
    }
  },
  filters: {
    imageFilter (value) {
      return service.url(value)
    }
  }
}
</script>

<template>
  <div class="p10">
    <div class="cover">
      <div class="article-meta">
        <div class="well">
          <h1 class="title">{{normcase.title || '我的经典病例'}}</h1>
          <p class="do">
            诊断&nbsp;&nbsp;
            <span class="text">{{normcase.diagnoseNames}}</span>
          </p>
          <p class="do">
            术式&nbsp;&nbsp;
            <span class="text">{{normcase.operatingNames}}</span>
          </p>
          <p class="time-author" v-if="normcase.createName">
            <span>{{normcase.createTime | dateFilter}}</span>
            <span class="nickname">{{normcase.createName}}</span>
            <span class="read">
              阅读&nbsp;&nbsp;
              <span>{{normcase.readCount || 0}}</span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="doctor">
      <div class="well">
        <a href="javascript:void(0);" class="doctor-link" @click="showDoctor">
          <div class="doctor-wrap clear">
            <div class="doctor-img fl">
              <img :src="normcase.operatorImage | headimgFilter">
            </div>
            <div class="doctor-info fl">
              <span class="doctor-name">{{normcase.operatorName}}</span>
              <span class="doctor-org">
                <span v-if="normcase.hname">{{normcase.hname}}</span>
                <span v-if="normcase.orgName"> . {{normcase.orgName}}</span>
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="nc-content">
      <div class="content-container">
        <div class="section" v-for="(paragraph, index) in paragraphs" :key="index">
          <div class="text well" v-if="paragraph.remark" v-html="paragraph.remark">
            <!-- {{paragraph.remark}} -->
          </div>
          <div class="img-box well" v-if="paragraph.image">
            <img v-if="isImage(paragraph.image)" :src="paragraph.image | imageFilter">
            <video v-else :src="paragraph.image | imageFilter" width="100%" height="auto" controls>您的浏览器不支持播放视频</video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.edit-main {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.well {
  padding: 0 16px;
}
.text {
  text-align: justify;
}
.cover {
  margin-top: 20px;
}
.cover .article-meta {
  overflow: hidden;
  text-align: center;
  word-wrap: break-word;
}
.cover .article-meta .title {
  font-size: 22px;
  line-height: 33px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
}
.cover .article-meta p.do {
  margin-top: 5px;
  font-size: 14px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 20px;
  text-align: left;
  word-break: break-all;
}
.cover .article-meta p.do .text {
  color: #333;
}
.cover .article-meta p.time-author {
  margin-top: 12px;
  font-size: 15px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 20px;
  text-align: left;
  word-break: break-all;
}
.cover .article-meta p.time-author > span {
  margin-right: 10px;
}
.cover .article-meta p.time-author > span:first-child {
  margin-right: 10px;
}
.cover .article-meta p.time-author > span.nickname {
  color: #6D9AD1;
}
.nc-content .section {
  margin: 40px 0;
}
.nc-content .section:first-child {
  margin-top: 0;
  margin-bottom: 40px;
}
.section .img-box {
  position: relative;
  margin: 15px 0;
}
.section .img-box img {
  width: 100%;
  vertical-align: bottom;
}
.section .text {
  margin: 15px 0;
  padding: 0 16px;
  line-height: 1.8;
  word-wrap: break-word;
  font-weight: normal;
  font-size: 17px;
}
.doctor {
  margin: 15px 0;
}
.doctor-link {
  display: block;
}
.doctor-wrap {
  background: #E4E7ED;
  padding: 10px;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  border: 1px solid #e1e6eb;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.doctor .doctor-img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.doctor .doctor-img img {
  width: 32px;
  height: 32px;
  display: block;
  border-radius: 50%;
  background: #409EFF;
  text-align: center;
  line-height: 32px;
  font-size: 32px;
  color: #F2F6FC;
  overflow: hidden;
}
.doctor .doctor-info {
  width: 100%;
  height: 100%;
  min-height: 65px;
  position: relative;
  padding: 0 0 0 50px;
  font-size: 14px;
  color: #909399;
  line-height: 32px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.doctor .doctor-info .doctor-name {
  display: block;
  font-size: 18px;
  color: #333;
}
.doctor .doctor-info .doctor-org {
  display: block;
}
</style>
